export default {
  filterPlaceholder: 'Filtruj według stanu',
  confirmReset: {
    header: 'Zresetować stan pliku "{filePathId}"?',
    message: 'Plik dziennika zostanie zachowany i ponownie zaimportowany w następnej rundzie wykrywania.',
  },
  resetSelected: 'Resetuj wybrane ({count})',
  confirmBulkReset: {
    header: 'Zresetować stan {count} plików dziennika?',
    message: 'Pliki dziennika zostaną zachowane i ponownie zaimportowane w następnej rundzie wykrywania.',
  },
};
